import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { BestellungExtern } from '../../bestellung-extern/bestellung-extern';
import { Gutschrift } from '../../gutschriften/gutschrift';
import { AddGutschriftDialogComponent } from '../../gutschriften/add-gutschrift-dialog/add-gutschrift-dialog.component';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MaterialDetailsComponent } from '../../../warehouse/material/material-details/material-details.component';

@Component({
    selector: 'kiene-show-gutschriften-dialog',
    templateUrl: './show-gutschriften-dialog.component.html',
    styleUrls: ['./show-gutschriften-dialog.component.css'],
})
export class ShowGutschriftenDialogComponent implements OnInit {
    bestellungExtern: BestellungExtern = new BestellungExtern();
    gutschriften: Gutschrift[] = [];

    constructor(
        public dialogRef: MatDialogRef<ShowGutschriftenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private pdfService: PdfViewerDesktopService,
        private readonly dialog: MatDialog,
        private readonly session: LocalStorageService,
    ) {
        this.bestellungExtern = data.bestellungExtern;
    }

    ngOnInit(): void {
        this.loadGutschriften();
    }

    loadGutschriften() {
        let params = new HttpParams();
        params = params.append('bestellung_extern_id', this.bestellungExtern.bestellung_extern_id.toString());
        this.api.get(this.apiBaseUrl + 'gutschrift/read_lieferanten.php', params).subscribe(response => {
            this.gutschriften = response.records;
        });
    }

    close() {
        this.dialogRef.close();
    }

    hasPermission(...ids: number[]) {
        return ids.some(id => this.session.currentUserHasPermission(id));
    }

    canEditGutschrift(g: Gutschrift): boolean {
        return (
            this.hasPermission(4102) &&
            !g?.primanota_id &&
            !g?.gutschrift_id_storno &&
            !g?.gutschrift_id_storniert &&
            !(Number(g?.scan_review) > 0)
        );
    }

    openGutschriftEdit(g: Gutschrift) {
        if (!this.canEditGutschrift(g)) {
            return;
        }
        this.dialog
            .open(AddGutschriftDialogComponent, {
                width: '560px',
                data: { gutschrift: g, apiUrl: 'gutschrift/update.php' },
            })
            .afterClosed()
            .subscribe(() => this.loadGutschriften());
    }

    openArtikelDetails(g: Gutschrift, event?: Event) {
        event?.stopPropagation();
        const id = Number(g?.artikel_id);
        if (!id || !this.hasPermission(1001)) {
            return;
        }
        this.dialog.open(MaterialDetailsComponent, {
            width: '1100px',
            maxWidth: '96vw',
            height: '90vh',
            autoFocus: false,
            panelClass: ['material-details-dialog-panel', 'mat-dialog-no-padding'],
            data: { artikelId: id },
        });
    }

    openPdf(g: Gutschrift, event?: Event) {
        event?.stopPropagation();
        let params = new HttpParams();
        params = params.set('pdf_id', g.pdf_id);
        params = params.set('gutschrift_id', g.gutschrift_id);
        const input = new PdfViewerDialogInput(
            'gutschrift/read_pdf.php',
            params,
            'Gutschrift ' + this.bestellungExtern.lieferant,
        );
        this.pdfService.openPdfViewer(input);
    }
}
